import { SingleJerseyWithStats } from '@/ui/components';
import type { SingleJerseyWithStatsProps } from '@/ui/components/SingleJerseyWithStats/SingleJerseyWithStats';

export interface TwoJerseysWithStatsProps {
  /** Home team column (first in LTR: jersey + number + league + stats). */
  homeConfig: SingleJerseyWithStatsProps;
  /** Away team column (second in LTR). */
  awayConfig: SingleJerseyWithStatsProps;
  /** Optional className for the root wrapper. */
  className?: string;
}

export default function TwoJerseysWithStats({
  homeConfig,
  awayConfig,
  className = '',
}: TwoJerseysWithStatsProps) {
  return (
    <div className={`flex flex-row items-stretch justify-between gap-[16px] w-full ${className}`}>
      <div className="flex-1 flex justify-center min-w-0">
        <SingleJerseyWithStats {...homeConfig} />
      </div>
      <div className="flex-1 flex justify-center min-w-0">
        <SingleJerseyWithStats {...awayConfig} />
      </div>
    </div>
  );
}
